import request from '@/utils/request';
import {
  TMPURL
} from './config';

// 获取工单历史记录
export function getTicketRecordList(params) {
  return request.post(TMPURL + '/v1/frontend/ticket/getTicketRecordList', params);
}
// 获取工单表单
export function getTicketRecordfield(params) {
  return request.get(TMPURL + '/v1/frontend/ticket/form/field', params);
}
// 获取工单表单类型
export function getTicketRecordModel(params) {
  return request.get(TMPURL + '/v1/frontend/ticket/form/model', params);
}

// 提交工单
export function subTicket(params) {
  return request.post(TMPURL + '/v1/frontend/selfService/subTicket', params);
}

// 获取工单详情
export function getReportDetail(params) {
  return request.get(TMPURL + '/v1/frontend/ticket/detail', params);
}

// 工单补全
export function completeTicket(params) {
  return request.post(TMPURL + '/v1/public/ticket/complete', params, true, true);
}

// 游戏渠道列表
export function getGameChannel(params) {
  return request.get(TMPURL + '/v1/public/ticket/channel', params);
}

// 工单评分
export function apiTicketScore(params) {
  return request.post(TMPURL + '/v1/public/ticket/score', params, true, true);
}

// 获取评分项
export function getStarItem(params) {
  return request.get(TMPURL + '/v1/public/ticket/star', params);
}

// 获取意愿项目
export function getWillingReason(params) {
  return request.get(TMPURL + '/v1/public/ticket/willing/reason', params);
}

// 提交意愿
export function updateWilling(params) {
  return request.post(TMPURL + '/v1/public/ticket/willing/update', params, true, true);
}

// 通过短链获取工单详情
export function getTicketDetail(params) {
  return request.get(TMPURL + '/v1/public/ticket/detail', params);
}

// 获取工单类型
export function getTicketModel(params) {
  return request.get(TMPURL + '/v1/public/selfService/getSelfFormList', params);
}

// 获取角色信息
export function getSelfRoleInfo(params) {
  return request.get(TMPURL + '/v1/frontend/selfService/roleInfo', params);
}

// 获取账号信息
export function getSelfAccountInfo(params) {
  return request.get(TMPURL + '/v1/frontend/selfService/accountInfo', params);
}

/* pulic工单接口 */

// 获取工单表单
export function getPublicTicketfield(params) {
  return request.get(TMPURL + '/v1/public/kf/form/field', params);
}

// 获取举报者信息
export function getPublicGetDecodeInfo(params) {
  return request.get(TMPURL + '/v1/public/kf/decode', params);
}

// 提交工单
export function getPublicSubmitTiket(params) {
  return request.post(TMPURL + '/v1/public/kf/subTicket', params);
}